import { createMuiTheme } from "@material-ui/core/styles";

const light = createMuiTheme({
  palette: {
    type: "light",
    primary: { main: "#8b5cf6" },
    secondary: { main: "#db2777" },
    background: {
      default: "#f0f2f5",
      paper: "#ffffff"
    },
    text: {
      primary: "#111827",
      secondary: "#6b7280"
    },
    divider: "#e5e7eb"
  },
  typography: {
    fontFamily:
      "Plus Jakarta Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
    h4: {
      fontWeight: 800,
      letterSpacing: "-0.02em"
    },
    h5: {
      fontWeight: 700
    },
    h6: {
      fontWeight: 700
    },
    button: {
      fontWeight: 600,
      textTransform: "none"
    },
    caption: {
      fontWeight: 700,
      letterSpacing: "0.05em"
    }
  },
  sidebar: {
    width: 260,
    collapsedWidth: 72
  }
});

const dark = createMuiTheme({
  palette: {
    type: "dark",
    primary: { main: "#a78bfa" },
    secondary: { main: "#f472b6" },
    background: {
      default: "#191c1e",
      paper: "#232628"
    },
    text: {
      primary: "#f3f4f6",
      secondary: "#9ca3af"
    },
    divider: "#374151"
  },
  typography: {
    fontFamily:
      "Plus Jakarta Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
    h4: {
      fontWeight: 800,
      letterSpacing: "-0.02em"
    },
    h5: {
      fontWeight: 700
    },
    h6: {
      fontWeight: 700
    },
    button: {
      fontWeight: 600,
      textTransform: "none"
    },
    caption: {
      fontWeight: 700,
      letterSpacing: "0.05em"
    }
  },
  sidebar: {
    width: 260,
    collapsedWidth: 72
  }
});

export const getTheme = (mode) => (mode === "dark" ? dark : light);

export default light;
